import React, { useState } from 'react';
import onClickOutside from 'react-onclickoutside';
import { Link } from 'react-router-dom';
import './DashBoardDropDown.scss';

const DashBoardDropDown = ({ name }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  DashBoardDropDown.handleClickOutside = () => setIsOpen(false);

  return (
    <div className="user-dashboard-toolbar-nav-profile" onClick={toggle}>
      <button className="user-dashboard-toolbar-nav-profile__btn">
        <img
          className="user-dashboard-toolbar-nav-profile__btn-img"
          src="https://cdn.dribbble.com/assets/avatar-default-aa2eab7684294781f93bc99ad394a0eb3249c5768c21390163c9f55ea8ef83a4.gif"
          alt=""
        />
      </button>
      <ul className={`tabs ${isOpen ? 'active-tabs' : ''}`}>
        <li className="tabs-profile">
          <Link to={`${name}/profile`} className="tabs-profile-link">
            {name.charAt(0).toUpperCase() + name.slice(1)}
          </Link>
        </li>
        <li className="tabs-profile">
          <Link to={`${name}/settings`} className="tabs-profile-link">
            Account settings
          </Link>
        </li>
        <li className="tabs-profile">
          <Link to="/logout" className="tabs-profile-link">
            Log Out
          </Link>
        </li>
      </ul>
    </div>
  );
};

const clickOutsideConfig = {
  handleClickOutside: () => DashBoardDropDown.handleClickOutside
};

export default onClickOutside(DashBoardDropDown, clickOutsideConfig);
